export {
  type ProfileGoals,
  type HydrationPlan,
  parseTimeToDecimal,
  calculateActiveHours,
  calculateBaseDailyRecommendation,
  calculateProratedTarget,
  calculateRemindersPerDay,
  calculateVolumePerReminder,
  computeHydrationPlan,
  syncProfileHydrationFields,
  resolveProratedDailyTargetMl,
  resolveDailyTargetMl,
  resolveGoalLitres,
  resolveVolumePerReminder,
  resolveFrequencyGoal,
  formatBaselineReminderInterval,
} from '@shared/hydrationGoals';

import { calculateCompleteHydrationMetrics } from '@/lib/goalCalculations';

/** Recommended daily target for edit/onboarding from profile inputs. */
export function resolveRecommendedDailyTargetMl(profile: {
  age?: number;
  gender?: string;
  activeHoursStart: string;
  activeHoursEnd: string;
  reminderInterval: number;
}): number {
  return calculateCompleteHydrationMetrics({
    age: profile.age,
    gender: profile.gender,
    activeHoursStart: profile.activeHoursStart,
    activeHoursEnd: profile.activeHoursEnd,
    reminderInterval: profile.reminderInterval,
  }).proratedGoal;
}
